import { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { loadFooterConfig } from 'arbitrip-common/theme/footer/helpers';
import Logo from './Logo';

const FooterBar = ({ profile, t }) => {
	const [config, setConfig] = useState({});

	useEffect(() => {
		async function fetchConfig() {
			if (profile?.company?.id && _.isEmpty(config)) {
				const loadedConfig = await loadFooterConfig(profile.company.id);
				setConfig(loadedConfig);
			}
		}
		fetchConfig();
	}, [profile]);

	const { Information, ...otherSections } = config;

	return (
		<footer>
			<div className="inner-container">
				{/* Render the Information section */}
				{Information && (
					<div className="section">
						{Information.Logo && <Logo src={t(Information.Logo)} alt="Footer Logo" />}
						{Information.Slogan && <span className="info-text slogan">{t(Information.Slogan)}</span>}
						{Information.CopyRight && (
							<span className="copyright">
								{t(Information.CopyRight, { year: new Date().getFullYear() })}
							</span>
						)}
					</div>
				)}

				{/* Render other sections */}
				{Object.entries(otherSections).map(([key, values]) => {
					const hasValidLinks = Object.values(values).some((value) => value && value.trim() !== '');
					return (
						hasValidLinks && (
							<div key={key} className="section">
								<span className="section-title">{t(key)}</span>
								{Object.entries(values).map(([label, urlKey]) => {
									const url = t(urlKey);
									if (!url || url.trim() === '') return null;

									const isInternal = url.startsWith('/');

									return isInternal ? (
										<Link key={label} to={url} className="footer-link">
											{t(label)}
										</Link>
									) : (
										<a
											key={label}
											href={url}
											target="_blank"
											rel="noopener noreferrer"
											className="footer-link"
										>
											{t(label)}
										</a>
									);
								})}
							</div>
						)
					);
				})}
			</div>
		</footer>
	);
};

export default withTranslation()(FooterBar);
